module.exports = __webpack_public_path__ + "img/user.b447cdb7.svg";